module.exports = __webpack_public_path__ + "img/taarih.ab7e2c42.jpg";